(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');

    // controller for tasks info
    module.controller('BlockUserModalController', [
        '$uibModalInstance',
        'userName',
        BlockUserModalController
    ]);

    function BlockUserModalController($uibModalInstance, userName) {
        var vm = this;

        vm.userName = userName;

        // cancel
        vm.no = function () {
            $uibModalInstance.dismiss();
        };

        // ok
        vm.yes = function () {
            $uibModalInstance.close();
        };      

    }

})();